export default __webpack_public_path__ + "shopify-brand.64c22558c2a3fa15177a29bbf47894e4.svg";